import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PendingRequestsTable } from "@/components/admin/PendingRequestsTable";
import { BusyPeriodManager } from "@/components/admin/BusyPeriodManager";
import { EventsArchive } from "@/components/admin/EventsArchive";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const AdminSection = () => {
  const { data: pendingCount } = useQuery({
    queryKey: ["pending_requests_count"],
    queryFn: async () => {
      const { count, error } = await supabase
        .from("vacation_requests")
        .select("*", { count: "exact", head: true })
        .eq("status", "pending");
      if (error) throw error;
      return count || 0;
    },
  });

  return (
    <div className="space-y-8 mb-8">
      {(pendingCount ?? 0) > 0 && (
        <Card className="p-6 hover:shadow-lg transition-shadow duration-300">
          <CardHeader>
            <CardTitle>
              Pending Vacation Requests
              <span className="block text-sm text-muted-foreground font-normal">
                Review and manage team vacation requests
              </span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <PendingRequestsTable />
          </CardContent>
        </Card>
      )}

      <BusyPeriodManager />

      <EventsArchive />
    </div>
  );
};